export const TEXT_FIELD_MAX_LENGTH = 100;
export const LONG_TEXT_FIELD_MAX_LENGTH = 200;
export const FIFTY_FIELD_MAX_LENGTH = 50;
export const CONTACT_NUMBER_FIELD_MAX_LENGTH = 10;
export const POSTCODE_FIELD_MAX_LENGTH = 4;
export const TRANSIENT_ERROR_TIMEOUT_MS = 1500;
export const MAX_CREDIT_REQUIRED_LENGTH = 19;